import { Link } from "react-router-dom";
import { UserData } from "@/common/types/users";
import { ArrowBigRight, UserRoundIcon } from "lucide-react";
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder";
import { userStatusTranslation } from "../../../common/constants/userStatus.constant";
import { formatDateTime } from "@/common/utils/formatters";

export class UsersTransformer {
  static tableTransformer() {
    return (users: UserData[]) => {
      return users.map((user) => ({
        ...user,
        role: !!user?.user_roles?.length ? (user?.user_roles?.map((userRole) => userRole.role.display_name).join(', ') || 'Não informado') : 'Não informado',
        fullName: (
          <div className="flex items-center gap-[10px]">
            <ImageWithPlaceholder
              url={user?.profile_picture?.url}
              alt={user?.full_name}
              className="size-6"
              iconClassName="size-4"
              placeholderIcon={UserRoundIcon}
            />
            <p>{user.full_name}</p>
          </div>
        ),
        lastSeenAt: user?.last_seen_at ? formatDateTime(new Date(user?.last_seen_at)) : "",
        status: userStatusTranslation[(user?.status || 'default') as keyof typeof userStatusTranslation],
        actions: <Link to={`/users/${user.id}`}><ArrowBigRight /></Link>
      }));
    }
  }

  static quickSearchModelTransformer() {
    return (users: UserData[]) => {
      return users.map((user) => ({
        route: `/users/${user.id}`,
        items: [
          ['Perfil', !!user?.user_roles?.length && (user?.user_roles?.map((userRole) => userRole.role.display_name).join(', '))],
          ['Nome', user.full_name],
        ],
      }));
    };
  }
}
